
import React, { useState } from "react";
import Rtl from "./Rtl";
import "./Theme.css";

const Theme = () => {
  const [theme, setTheme] = useState("theme1");

  const handleThemeChange = (newTheme) => {
    setTheme(newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
  };

  return (
    <div className="app d-flex gap-10">
      
      <button class="btn btn-white btn-sm" onClick={() => handleThemeChange("Light")}>Light</button>
      <button className="btn btn-dark btn-sm" onClick={() => handleThemeChange("Dark")}>Dark</button>
      {/* <button onClick={() => handleThemeChange("theme3")}>Theme 3</button> */}
      
      <Rtl />
    </div>
  );
};

export default Theme;
